import { defineComponent as S, computed as l, openBlock as c, createBlock as h, resolveDynamicComponent as b, normalizeStyle as y, withCtx as x, createElementBlock as k } from "vue";
import { KUI_ICON_SIZE_50 as d } from "./kong-icons.es1628.js";
const z = ["aria-hidden"], u = '<path d="M6.55 16.5L8 14C6.9 14 5.95833 13.6083 5.175 12.825C4.39167 12.0417 4 11.1 4 10C4 8.9 4.39167 7.95833 5.175 7.175C5.95833 6.39167 6.9 6 8 6C9.1 6 10.0417 6.39167 10.825 7.175C11.6083 7.95833 12 8.9 12 10C12 10.3833 11.9542 10.7375 11.8625 11.0625C11.7708 11.3875 11.6333 11.7 11.45 12L8.275 17.5C8.19167 17.65 8.075 17.7708 7.925 17.8625C7.775 17.9542 7.60833 18 7.425 18C7.04167 18 6.75417 17.8333 6.5625 17.5C6.37083 17.1667 6.36667 16.8333 6.55 16.5ZM15.55 16.5L17 14C15.9 14 14.9583 13.6083 14.175 12.825C13.3917 12.0417 13 11.1 13 10C13 8.9 13.3917 7.95833 14.175 7.175C14.9583 6.39167 15.9 6 17 6C18.1 6 19.0417 6.39167 19.825 7.175C20.6083 7.95833 21 8.9 21 10C21 10.3833 20.9542 10.7375 20.8625 11.0625C20.7708 11.3875 20.6333 11.7 20.45 12L17.275 17.5C17.1917 17.65 17.075 17.7708 16.925 17.8625C16.775 17.9542 16.6083 18 16.425 18C16.0417 18 15.7542 17.8333 15.5625 17.5C15.3708 17.1667 15.3667 16.8333 15.55 16.5Z" fill="currentColor"/>', B = /* @__PURE__ */ S({
  __name: "BlockquoteIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: d,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (i) => {
        if (typeof i == "number" && i > 0)
          return !0;
        if (typeof i == "string") {
          const e = String(i).replace(/px/gi, ""), r = Number(e);
          if (r && !isNaN(r) && Number.isInteger(r) && r > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(i) {
    const e = i, r = l(() => {
      if (typeof e.size == "number" && e.size > 0)
        return `${e.size}px`;
      if (typeof e.size == "string") {
        const n = String(e.size).replace(/px/gi, ""), t = Number(n);
        if (t && !isNaN(t) && Number.isInteger(t) && t > 0)
          return `${t}px`;
      }
      return d;
    }), g = l(() => ({
      boxSizing: "border-box",
      color: e.color,
      display: e.display,
      flexShrink: "0",
      height: r.value,
      lineHeight: "0",
      width: r.value,
      pointerEvents: e.decorative ? "none" : void 0
    })), p = (n) => {
      const t = {}, v = Math.random().toString(36).substring(2, 12);
      return n.replace(/id="([^"]+)"/g, (s, o) => {
        const a = `${v}-${o}`;
        return t[o] = a, `id="${a}"`;
      }).replace(/#([^\s^")]+)/g, (s, o) => t[o] ? `#${t[o]}` : s);
    }, f = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, C = (n) => n.replace(/[<>"'&]/g, (t) => f[t]), m = `${e.title ? `<title data-testid="kui-icon-svg-title">${C(e.title)}</title>` : ""}${e.staticIds ? u : p(u)}`;
    return (n, t) => (c(), h(b(i.as), {
      "aria-hidden": i.decorative ? "true" : void 0,
      class: "kui-icon blockquote-icon",
      "data-testid": "kui-icon-wrapper-blockquote-icon",
      style: y(g.value),
      tabindex: i.decorative ? "-1" : void 0
    }, {
      default: x(() => [
        (c(), k("svg", {
          "aria-hidden": i.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-blockquote-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: m
        }, null, 8, z))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
});
export {
  B as default
};
